module.exports = __webpack_public_path__ + "static/opennet-31351092b0c29e8cd3601f35df7e26a4.png";